import axiosInstance from "../helpers/axiosInstance";

const BASE_URL = `${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores`;

export const fetchContainerTemplates = async (storeId, params = {}) => {
    const res = await axiosInstance.get(`${BASE_URL}/${storeId}/container-content-templates`, { params });
    return res.data;
};

export const createContainerTemplate = async (storeId, payload) => {
    const res = await axiosInstance.post(`${BASE_URL}/${storeId}/container-content-templates`, payload);
    return res.data;
};

export const updateContainerTemplate = async (storeId, templateId, payload) => {
    const res = await axiosInstance.put(`${BASE_URL}/${storeId}/container-content-templates/${templateId}`, payload);
    return res.data;
};

export const deleteContainerTemplate = async (storeId, templateId) => {
    const res = await axiosInstance.delete(`${BASE_URL}/${storeId}/container-content-templates/${templateId}`);
    return res.data;
};

export const searchProducts = async (params = {}) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/products`, { params });
    return res.data;
};

export const fetchProduct = async (productId) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/products/${productId}`);
    return res.data;
};

export const fetchProductLots = async (productId) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/products/${productId}/lots`);
    return res.data;
};
